export enum FraudControlDataProviderName {
  CYBERTONICA = "CYBERTONICA",
  SEON = "SEON",
  DISABLED = "DISABLED",
}
